
<main>
    <div class="loginWraper">
        <div class="title">
            <h2>ધડુક પરિવારમાં આપનું સ્વાગત છે!</h2>
        </div>
        <form [formGroup]="signUp">

            <div class="form-group">
                <input type="text" class="form-control" placeholder="નામ" formControlName="userName" />
                <div *ngIf="submitted && f.userName.errors" class="error-message">
                    <small *ngIf="f.userName.errors?.required" class="text-danger">નામ જરૂરી છે.</small>
                </div>
                <div *ngIf="f.userName.errors?.pattern && f.userName.touched" class="error-message">
                    <small class="text-danger">ફક્ત મૂળાક્ષરોની મંજૂરી છે.</small>
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="form-control" placeholder="મોબાઇલ નંબર" formControlName="contact_no"
                    maxlength="15" />
                <div *ngIf="submitted && f.contact_no.errors" class="error-message">
                    <small *ngIf="f.contact_no.errors?.required" class="text-danger">સંપર્ક નંબર જરૂરી છે.</small>
                </div>
                <div *ngIf="f.contact_no.errors?.pattern && f.contact_no.touched" class="error-message">
                    <small *ngIf="f.contact_no.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
                </div>
                <div *ngIf="f.contact_no.errors?.minlength && f.contact_no.touched" class="error-message">
                    <small *ngIf="f.contact_no.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                        છે.</small>
                </div>
            </div>

            <div class="form-group position-relative">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="પાસવર્ડ"
                    formControlName="password" />
                <span class="passEye" (click)="password()">
                    <i style="cursor: pointer;" class="ti ti-eye" *ngIf="showPassword"></i>
                    <i style="cursor: pointer;" class="ti ti-eye-off" *ngIf="!showPassword"></i>
                </span>
                <div *ngIf="submitted && f.password.errors" class="error-message">
                    <small *ngIf="f.password.errors?.required" class="text-danger">પાસવર્ડ જરૂરી છે.</small>
                </div>
            </div>

            <div class="form-group position-relative">
                <input [type]="confirmPassword ? 'text' : 'password'" class="form-control"
                    placeholder="કન્ફર્મ પાસવર્ડ" formControlName="cpassword" />
                <span class="passEye" (click)="confirmPwd()">
                    <i style="cursor: pointer;" class="ti ti-eye" *ngIf="confirmPassword"></i>
                    <i style="cursor: pointer;" class="ti ti-eye-off" *ngIf="!confirmPassword"></i>
                </span>
                <div *ngIf="submitted && f.cpassword.errors" class="error-message">
                    <small *ngIf="f.cpassword.errors?.required" class="text-danger"> કન્ફર્મ પાસવર્ડ જરૂરી છે.</small>
                    <small *ngIf="f.cpassword.errors.mustMatch" class="text-danger">
                        બંને પાસવર્ડ મેળ ખાતા નથી
                    </small>
                </div>
            </div>

            <button type="submit" class="btn-common" (click)="goToLogin()">સાઇન અપ</button>
        </form>
    </div>
</main>